import * as storeApi from '../../api/storeApi'
const state = {
    NavigationOutput:[],
    AddInput:{},
    AddOuput:{},
    RecordInput:{},
    List: [],
    HasMore: true,
    PageIndex:0,
}

const getters = {

}

const actions = {
    async GetNavigation({ commit }, params) {
        const response = await storeApi.GetNavigation(params);
        if (response.Status) {
            commit('SetNavigation', response.Data)
        }
        return response;
    },
    async ImportParts({ commit }, params) {
        const response = await storeApi.ImportParts(params);
        return response;
       
    },
    async recordLists({commit}, RecordInput) {
        const response = await storeApi.RecordLists(RecordInput);
        if (response.Status) {
          if (response.PageNo >= response.PageCount) {
            commit('setHasMore', false)
          } else {
            commit('setHasMore', true)    
          }
          if(RecordInput.PageIndex === 1){
            commit('emptyState')
          }
          commit('setPageIndex', response.PageNo + 1)
          commit('recordList', response);
        }else {
          commit('setHasMore', false)
        }
        return response
    },
    async StoreGetOneCode({commit}, code){
        const response = await storeApi.StoreGetOneCode(code);
        return response;
	},
    EmptyState({commit}){
        commit('emptyState')
      }
}

const mutations = {
    SetNavigation(state, data) {
        state.NavigationOutput = data
    },
    importParts(state,data){
        state.AddInput = data
    },
    recordList(state, data)
	{
        state.List = state.List.concat(data.Rows)
    },
    setHasMore(state, hasMore) {
        state.HasMore = hasMore
    },
    setPageIndex(state, pageIndex) {
        state.RecordInput.PageIndex = pageIndex
    },
    emptyState(state){
        state.List = [];
        state.HasMore = true;
        state.PageIndex = 0;
      }
}

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/storeadd.js